// extracted by mini-css-extract-plugin
export var configurationSection = "_za-0";